module.exports = __webpack_public_path__ + "static/media/warning.f31bfd8c.svg";